export default __webpack_public_path__ + "static/media/active-pie-chart.99e4d545.svg";